import React from 'react';
import PropTypes from 'prop-types';
import FollowButton from '../shared/follow-button';
import Loading from '../../shared/loading';
import defaultOnErrorHandler from '../../shared/default-on-error-handler';
import { useFollow, useUnfollow } from '../../services/stock-codes/follow-service';

export default function StockCodeFollowButton({ stockCode }) {
  const [followed, setFollowed] = React.useState(stockCode.isStockCodeFollowedByCurrentUser);
  const [{ loading: followLoading }, follow] = useFollow();
  const [{ loading: unfollowLoading }, unfollow] = useUnfollow();
  const loadingRef = React.useRef();

  React.useEffect(() => {
    loadingRef.current && loadingRef.current.toggle(followLoading || unfollowLoading);
  }, [followLoading, unfollowLoading]);

  const followStockCode = () => {
    follow(stockCode.slug).then(() => {
      setFollowed(true);
    }).catch(err => {
      defaultOnErrorHandler(err, 'Error following this stock code');
    });
  };

  const unfollowStockCode = () => {
    unfollow(stockCode.slug).then(() => {
      setFollowed(false);
    }).catch(err => {
      defaultOnErrorHandler(err, 'Error unfollowing this stock code');
    });
  };

  const toggle = () => {
    loadingRef.current.start({
      onFadeInComplete: () => {
        if (followed) {
          unfollowStockCode();
        } else {
          followStockCode();
        }
      },
    });
  };

  return (
    <Loading ref={loadingRef} variant="button">
      <FollowButton followed={followed} onToggle={toggle} />
    </Loading>
  );
}

StockCodeFollowButton.propTypes = {
  stockCode: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    isStockCodeFollowedByCurrentUser: PropTypes.bool.isRequired,
  }).isRequired,
};
